export default __webpack_public_path__ + "static/media/google.9d00820e.jpg";